import { ComponentType as r } from "../../registries/types/propTypes.js";
import { transformContentCardCommonData as t } from "../article-card-transformer/article-card-transformer.js";
const s = (o) => {
  const e = t(o);
  let n = {};
  return o && (n = {
    subTitleLineOne: o == null ? void 0 : o.sub_title_1,
    subTitleLineTwo: o == null ? void 0 : o.sub_title_2
  }), {
    componentType: r.promotion_card,
    ...e,
    ...n
  };
};
export {
  s as default
};
//# sourceMappingURL=promotion-card-transformer.js.map
